const lineHeights = {
  body: 1.5,
  headerLoose: 1.4,
  heading: 1.2
};

export default lineHeights;
